// photosLanding.js
import sm1 from '../Assets/SocialMedia/s1.png'
import sm2 from '../Assets/SocialMedia/s2.png'
import sm3 from '../Assets/SocialMedia/s3.png'
import sm4 from '../Assets/SocialMedia/s4.png'
import sm5 from '../Assets/SocialMedia/s5.png'
import sm6 from '../Assets/SocialMedia/s6.jpg'
import sm7 from '../Assets/SocialMedia/s7.png'
import sm8 from '../Assets/SocialMedia/s8.jpg'
import sm9 from '../Assets/SocialMedia/s9.png'
import sm10 from '../Assets/SocialMedia/s10.jpg'
import sm11 from '../Assets/SocialMedia/s11.png'
import sm12 from '../Assets/SocialMedia/s12.png'
import sm13 from '../Assets/SocialMedia/s13.png'
import sm14 from '../Assets/SocialMedia/s14.png'
import sm15 from '../Assets/SocialMedia/s15.png'
import sm16 from '../Assets/SocialMedia/s16.png'
import sm17 from '../Assets/SocialMedia/s17.png'
import sm18 from '../Assets/SocialMedia/s18.png'
import sm19 from '../Assets/SocialMedia/s19.png'
import sm20 from '../Assets/SocialMedia/s20.png'
import sm21 from '../Assets/SocialMedia/s21.png'
import sm22 from '../Assets/SocialMedia/s22.png'
import sm24 from '../Assets/SocialMedia/s24.png'
import sm25 from '../Assets/SocialMedia/s25.png'
import sm26 from '../Assets/SocialMedia/s26.jpg'
import sm27 from '../Assets/SocialMedia/s27.png'
import sm28 from '../Assets/SocialMedia/s28.png'
import sm29 from '../Assets/SocialMedia/s29.png'
import sm30 from '../Assets/SocialMedia/s30.png'
import sm31 from '../Assets/SocialMedia/s31.png'
import sm32 from '../Assets/SocialMedia/s32.png'
import sm33 from '../Assets/SocialMedia/s33.png'
import sm34 from '../Assets/SocialMedia/s34.png'
import sm35 from '../Assets/SocialMedia/p1.png'
import sm36 from '../Assets/SocialMedia/p2.png'
import sm37 from '../Assets/SocialMedia/p3.png'
import sm38 from '../Assets/SocialMedia/p4.png'
import sm39 from '../Assets/SocialMedia/p5.png'
import sm40 from '../Assets/SocialMedia/p6.png'
import sm41 from '../Assets/SocialMedia/p7.png'
import sm42 from '../Assets/SocialMedia/p8.png'
import sm43 from '../Assets/SocialMedia/p9.png'
export const photosLanding = [
  {
    src: sm1,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm2,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: sm43,
    width: 4,
    height: 5,
    title: 'Promo',
  },
  {
    src: sm3,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm4,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: sm5,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm36,
    width: 3,
    height: 4,
    title: 'Promo',
  },
  {
    src: sm6,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: sm7,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },

  {
    src: sm9,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm10,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: sm37,
    width: 4,
    height: 5,
    title: 'Promo',
  },
  {
    src: sm12,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: sm8,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: sm14,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: sm35,
    width: 3,
    height: 4,
    title: 'Hero Visual',
  },
  {
    src: sm13,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },

  {
    src: sm17,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm18,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: sm40,
    width: 3,
    height: 4,
    title: 'Hero Visual',
  },
  {
    src: sm11,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm19,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },

  {
    src: sm20,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: sm16,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: sm21,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm22,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: sm39,
    width: 4,
    height: 5,
    title: 'Promo',
  },
  {
    src: sm24,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: sm15,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm25,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm26,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: sm28,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: sm41,
    width: 4,
    height: 5,
    title: 'Promo',
  },
  {
    src: sm29,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm30,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: sm31,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm32,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: sm33,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm34,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: sm38,
    width: 2,
    height: 3,
    title: 'Hero Visual',
  },
  {
    src: sm27,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: sm42,
    width: 4,
    height: 5,
    title: 'Hero Visual',
  },
]
